
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  logoTitleDefault: {
    id: "LogoTitle.default",
    defaultMessage: "Configuration Overview",
  },
  logoTitleFallback: {
    id: "LogoTitle.fallback",
    defaultMessage: "KWC 3D Configurator",
  },
});

export default MESSAGES;